var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BSCTooltip",on:{"click":_vm.clickTooltip}},[_c('div',{staticClass:"BSCTooltip-slot",class:[
      `is-${_vm.position}`,
      { 'is-show': _vm.show },
      { 'is-clickable': _vm.isClickable },
      `is-${_vm.type}`
    ]},[_vm._t("content")],2),(_vm.show)?_c('div',{staticClass:"BSCTooltip-bk",on:{"click":function($event){$event.stopPropagation();_vm.show = false}}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }